import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import minMax from "dayjs/plugin/minMax";

dayjs.extend(isSameOrAfter);
dayjs.extend(minMax);

const FORMAT = "YYYY-MM-DD";

export type Range = { start: string; end: string };

export function weekRange(): Range {
  return {
    start: dayjs().subtract(1, "week").startOf("week").format(FORMAT),
    end: dayjs().subtract(1, "week").endOf("week").format(FORMAT),
  };
}

export function monthRange(): Range {
  return {
    start: dayjs().subtract(1, "month").startOf("month").format(FORMAT),
    end: dayjs().subtract(1, "month").endOf("month").format(FORMAT),
  };
}

export function yearRange(): Range {
  return {
    start: dayjs().subtract(1, "year").startOf("year").format(FORMAT),
    end: dayjs().subtract(1, "year").endOf("year").format(FORMAT),
  };
}

export function customRange(from: dayjs.ConfigType, to: dayjs.ConfigType): Range {
  const start = dayjs.min(dayjs().subtract(1, "day"), dayjs(from));
  const end = dayjs.min(dayjs().subtract(1, "day"), dayjs(to));
  return { start: start.format(FORMAT), end: end.format(FORMAT) };
}

export function nextRange(start: string, end: string, interval: string): Range {
  if (interval === "custom") {
    const span = dayjs(end).diff(dayjs(start), "day");
    return {
      start: dayjs(start).add(span + 1, "day").format(FORMAT),
      end: dayjs(end).add(span + 1, "day").format(FORMAT),
    };
  }
  const unit = interval as dayjs.ManipulateType;
  const newStart = dayjs(end).add(1, unit).startOf(unit as dayjs.OpUnitType);
  // Do not advance past today: leave the range unchanged.
  if (newStart.isAfter(dayjs())) {
    return { start, end };
  }
  const newEnd = dayjs(end).add(1, unit).endOf(unit as dayjs.OpUnitType);
  return {
    start: newStart.format(FORMAT),
    end: (newEnd.isAfter(dayjs()) ? dayjs().subtract(1, "day") : newEnd).format(FORMAT),
  };
}

export function prevRange(start: string, end: string, interval: string): Range {
  if (interval === "custom") {
    const span = dayjs(end).diff(dayjs(start), "day");
    return {
      start: dayjs(start).subtract(span + 1, "day").format(FORMAT),
      end: dayjs(end).subtract(span + 1, "day").format(FORMAT),
    };
  }
  const unit = interval as dayjs.ManipulateType;
  return {
    start: dayjs(start).subtract(1, unit).startOf(unit as dayjs.OpUnitType).format(FORMAT),
    end: dayjs(end).subtract(1, unit).endOf(unit as dayjs.OpUnitType).format(FORMAT),
  };
}
